import React, { useEffect, useState } from 'react'

export default function CustomRangeComponent({ value, onChange, allowedValues = [6, 6.5, 7, 8, 9] }) {
    const [numberList, setNumberList] = useState(allowedValues);

    // when slider changes
    const changeHandle = (e) => {
        const selectedIndex = Number(e.target.value);
        const val = allowedValues[selectedIndex];
        onChange(val); // send to parent
    }

    const incrementHandle = () => {
        const currentIndex = allowedValues.indexOf(value);
        const nextIndex = currentIndex === -1 ? 0 : Math.min(currentIndex + 1, allowedValues.length - 1);
        onChange(allowedValues[nextIndex]);
    }

    const decrementHandle = () => {
        const currentIndex = allowedValues.indexOf(value);
        const nextIndex = currentIndex === -1 ? 0 : Math.max(currentIndex - 1, 0);
        onChange(allowedValues[nextIndex]);
    }

    useEffect(() => {
        setNumberList(allowedValues);
        if (!allowedValues.includes(value) && allowedValues.length > 0) {
            onChange(allowedValues[0]);
        }
    }, [allowedValues, onChange, value])

    const selectedIndex = Math.max(allowedValues.indexOf(value), 0);

    return (
        <div className='customRangeComponent'>
            <div className='w-100 fs14 d-flex justify-content-between'>
                <p className='mg-text-gray1'>Teaser</p>
                <p className='fs13 mg-text-white1'>{value}-Points</p>
            </div>
            <div className='rangePart'>
                <button onClick={decrementHandle}>-</button>
                <div>
                    <input
                        onChange={changeHandle}
                        value={selectedIndex}
                        type="range"
                        min={0}
                        max={Math.max(allowedValues.length - 1, 0)}
                        step={1}
                    />
                    <ul className='fs12'>
                        {numberList.map((item, index) => (
                            <li
                                key={index}
                                onClick={() => onChange(item)}
                                className={value === item ? "isCurrentValue" : ""}
                            >
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
                <button onClick={incrementHandle}>+</button>
            </div>
        </div>
    )
}
